import { render, staticRenderFns } from "./title_onecolorbg.vue?vue&type=template&id=71dbb0f1&scoped=true&"
import script from "./title_onecolorbg.vue?vue&type=script&lang=js&"
export * from "./title_onecolorbg.vue?vue&type=script&lang=js&"
import style0 from "./title_onecolorbg.vue?vue&type=style&index=0&id=71dbb0f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dbb0f1",
  null
  
)

export default component.exports